<template>
    <div style="padding: 80px 20px 20px 240px">
    NOT FOUND
</div>
</template>